import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MdHotel } from 'react-icons/md';
import { FaFacebookF, FaInstagram, FaTwitter, FaYoutube, FaLinkedinIn } from 'react-icons/fa';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaClock, FaPaperPlane } from 'react-icons/fa';
import './Footer.css';

const quickLinks = [
  { path: '/', label: 'Home' },
  { path: '/about', label: 'About Us' },
  { path: '/rooms', label: 'Rooms & Suites' },
  { path: '/booking', label: 'Book Now' },
  { path: '/gallery', label: 'Gallery' },
  { path: '/contact', label: 'Contact Us' },
];

const servicesLinks = [
  { path: '/services', label: 'Services & Amenities' },
  { path: '/offers', label: 'Special Offers' },
  { path: '/testimonials', label: 'Testimonials' },
  { path: '/faq', label: 'FAQ' },
];

const socialLinks = [
  { icon: FaFacebookF, href: '#', label: 'Facebook' },
  { icon: FaInstagram, href: '#', label: 'Instagram' },
  { icon: FaTwitter, href: '#', label: 'Twitter' },
  { icon: FaYoutube, href: '#', label: 'YouTube' },
  { icon: FaLinkedinIn, href: '#', label: 'LinkedIn' },
];

export default function Footer() {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
    }
  };

  return (
    <footer className="footer">
      <div className="footer-top">
        <div className="container footer-top-inner">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <MdHotel className="footer-logo-icon" />
              <div>
                <span className="footer-logo-name">Grand Luxe</span>
                <span className="footer-logo-subtitle">Hotel & Spa</span>
              </div>
            </Link>
            <p className="footer-brand-desc">
              Experience the pinnacle of luxury hospitality. Where every detail is crafted
              to create memories that last a lifetime.
            </p>
            <div className="footer-socials">
              {socialLinks.map(({ icon: Icon, href, label }) => (
                <a key={label} href={href} className="social-btn" aria-label={label}>
                  <Icon />
                </a>
              ))}
            </div>
          </div>

          <div className="footer-links-col">
            <h4 className="footer-col-title">Quick Links</h4>
            <ul>
              {quickLinks.map(l => (
                <li key={l.path}>
                  <Link to={l.path} className="footer-link">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-links-col">
            <h4 className="footer-col-title">Our Services</h4>
            <ul>
              {servicesLinks.map(l => (
                <li key={l.path}>
                  <Link to={l.path} className="footer-link">{l.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-contact-col">
            <h4 className="footer-col-title">Contact Us</h4>
            <ul className="footer-contact-list">
              <li>
                <FaMapMarkerAlt className="contact-icon" />
                <span>123 Luxury Boulevard, Manhattan, New York, NY 10001</span>
              </li>
              <li>
                <FaPhoneAlt className="contact-icon" />
                <a href="tel:+18005551234">+1 (800) 555-1234</a>
              </li>
              <li>
                <FaEnvelope className="contact-icon" />
                <a href="mailto:sales@rstechservices.in">sales@rstechservices.in</a>
              </li>
              <li>
                <FaClock className="contact-icon" />
                <span>Check-in: 3PM · Check-out: 12PM</span>
              </li>
            </ul>

            <div className="footer-newsletter">
              <p className="newsletter-label">Subscribe to our newsletter</p>
              {subscribed ? (
                <p className="newsletter-success">Thank you for subscribing!</p>
              ) : (
                <form onSubmit={handleSubscribe} className="newsletter-form">
                  <input
                    type="email"
                    placeholder="Your email address"
                    value={email}
                    onChange={e => setEmail(e.target.value)}
                    required
                  />
                  <button type="submit"><FaPaperPlane /></button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="container footer-bottom-inner">
          <p>© {new Date().getFullYear()} Grand Luxe Hotel & Spa. All rights reserved.</p>
          <div className="footer-bottom-links">
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/terms">Terms & Conditions</Link>
            <Link to="/sitemap">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
